import { Box, styled } from "@mui/material";

export const CardWrapper = styled(Box)({
    alignItems: 'center',
    height: '50px',
    display: 'flex',
    justifyContent: 'center',
  });